var getRowRange = function getRowRange(_ref) {
  var rowsPerPage = _ref.rowsPerPage,
      pageIndex = _ref.pageIndex,
      totalRows = _ref.totalRows;
  var from = 1;
  var to = totalRows;

  if (rowsPerPage) {
    from = pageIndex * rowsPerPage + 1;

    if (!(totalRows < (pageIndex + 1) * rowsPerPage)) {
      to = (pageIndex + 1) * rowsPerPage;
    }
  }

  return {
    from: from,
    to: to
  };
};

export { getRowRange };
